export default "__VITE_ASSET__Dcekfi1r__"